import { ReactElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import leaflet, { BaseIconOptions, DivIconOptions } from "leaflet";

import { ReactComponent as StoreMarker } from "assets/Markers/store.svg";
import { ReactComponent as AgentMarker } from "assets/Markers/agent.svg";
import { ReactComponent as OfflineAgentMarker } from "assets/Markers/agent-offline.svg";
import { ReactComponent as PatrimonyMarker } from "assets/Markers/patrimony.svg";
import { ReactComponent as VehicleMarker } from "assets/Markers/occurrence.svg";

type SVGComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const iconConfig: BaseIconOptions = {
  iconSize: [35, 35],
};

const formatColoredIcon = (svg: ReactElement): DivIconOptions => {
  return {
    html: renderToStaticMarkup(svg),
    ...iconConfig,
  };
};

type Props = {
  color?: string;
  type:
    | "policeman"
    | "policemanOnDuty"
    | "store"
    | "occVehicle"
    | "occPatrimony";
};

type MarkerList = {
  [key: string]: {
    component: SVGComponent;
    defaultColor: string;
  };
};

const markers: MarkerList = {
  policeman: {
    component: AgentMarker,
    defaultColor: "#191919",
  },
  policemanOnDuty: {
    component: OfflineAgentMarker,
    defaultColor: "#191919",
  },
  occPatrimony: {
    component: PatrimonyMarker,
    defaultColor: "#FF8F01",
  },
  occVehicle: {
    component: VehicleMarker,
    defaultColor: "#FF8F01",
  },
  store: {
    component: StoreMarker,
    defaultColor: "#FF8F01",
  },
};

function MapMarker({ color, Marker }: { color: string; Marker: SVGComponent }) {
  return <Marker stroke={color} />;
}

export function markerIcon({ color, type }: Props) {
  const hexCode: string = color || markers[type].defaultColor;

  return new leaflet.DivIcon(
    formatColoredIcon(
      <div className="teste">
        <MapMarker color={hexCode} Marker={markers[type].component} />
      </div>
    )
  );
}
